import { call, put, select, takeEvery, all } from 'redux-saga/effects';
import {
    SET_SYSTEM,
    SYSTEM_HANDLE_FORCE_CHECK_VALIDATION,
    GET_DOWNLOAD_DOCUMENT,
    SET_FORMATTED_HOSPITAL_DATA,
    GET_DOWNLOAD_GENERATE_DOC,
    LOAD_ALL_CONFIG,
    EXPORT_APPLICATION_SEARCH,
    EXPORT_APPLICATION_SEARCH_NTEC,
    DOWNLOAD_APPLICATION,
    INITIAL_SYSTEM_GLOBAL_DATA,
    GET_SIGNED_DOCUMENT,
    SET_EMAIL_DOMAIN,
    GET_POST_APPROVAL_ZIP,
    EXPORT_FOR_CCO,
} from 'store/key';
import { produce } from 'utility/general';

import API from 'api/call';
import { safeSaga } from 'store';
import { setGlobalLoading } from 'store/global/reducer';

const initialState = {
    hospitals: [],
    FilesHistoryList: [
        // {
        //     id: '1',
        //     number: '123',
        //     fileName: 'fileName',
        //     effectiveOrAmendmentDate: '2021-06-10',
        //     uploadedBy: 'Uploaded By',
        //     uploadDate: 'Upload Date',
        // },
        // {
        //     id: '2',
        //     number: '1234',
        //     fileName: 'fileName',
        //     effectiveOrAmendmentDate: '2021-06-10',
        //     uploadedBy: 'Uploaded By',
        //     uploadDate: 'Upload Date',
        // },
    ],
    contactList: [
        {
            id: '0',
            officeName: 'HKEC',
            contact: '2595 6451 / 2595 5561',
            email: 'hkececsec@ha.org.hk',
        },
        // {
        //     id: '1',
        //     officeName: 'HKWC',
        //     contact: '2255 4086 / 2255 3923 / 2255 6788',
        //     email: 'hkwirb@ha.org.hk',
        // },
        {
            id: '2',
            officeName: 'KCC / KEC',
            contact: '3506 8407 / 3506 8406',
            email: 'kckecrec@ha.org.hk',
        },
        // {
        //     id: '3',
        //     officeName: 'HKEC',
        //     contact: '2595 6451 / 2595 5561',
        //     email: 'hkececsec@ha.org.hk',
        // },
        {
            id: '4',
            officeName: 'KWC',
            contact: '2990 1047 / 2990 3698 / 2990 1017',
            email: 'kwcrec@ha.org.hk',
        },
        // {
        //     id: '5',
        //     officeName: 'NTEC',
        //     contact: '3505 3935 / 3505 4275 / 2144 5926',
        //     email: 'crec@cuhk.edu.hk',
        // },
        {
            id: '6',
            officeName: 'NTWC',
            contact: '3767 7866',
            email: 'ntwcrec@ha.org.hk',
        },
        // {
        //     id: '7',
        //     officeName: 'HKCH',
        //     contact: '3513 3193',
        //     email: 'hkchrec@ha.org.hk',
        // },
    ],
    systemNewsAndBroadCastMsg: {
        broadcastMessage: '',
        news: '',
    },
    forceCheckValidation: false,
    formattedHospitalData: [],
    allConfig: {
        list: [],
        uploadFileMaxSize: 50 * 1024 * 1024,
        executableFiles: [],
    },
};

function* handleForceCheckValidation(action) {
    const { forceCheckValidation } = action.payload;
    const { system: state } = yield select();
    state.forceCheckValidation = forceCheckValidation;
    yield put({
        type: SET_SYSTEM,
        payload: state,
    });
}

/** get download document start */
export const mapContent = (resp) => {
    let contentDisposition = resp.headers['content-disposition'];
    let fileName = '';
    if (contentDisposition) {
        fileName = window.decodeURI(resp.headers['content-disposition'].split('=')[1], 'UTF-8');

        const tempName = fileName?.replaceAll?.(`"`, '');

        if (tempName) {
            fileName = tempName;
        }
    }

    let link = document.createElement('a');

    const isFileNameContainsExtension = fileName?.includes('.');

    if (!isFileNameContainsExtension) {
        // avoid adding extension in chrome browser when downloading file
        link.href = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/mikey' }));
    } else {
        link.href = window.URL.createObjectURL(new Blob([resp.data]));
    }

    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

function* getPostApprovalZip(action) {
    const { docType, docId, final = () => null } = action.payload;
    setGlobalLoading(true);
    try {
        const resp = yield call(API.approval.downloadDocumentZipFile, { docType, docId });
        mapContent(resp);
    } catch (err) {
        console.log(err);
    }
    setGlobalLoading(false);
    final();
}

function* getSignedForm(action) {
    const { docType, reportId, final = () => null } = action.payload;
    setGlobalLoading(true);
    try {
        const resp = yield call(API.approval.downloadSignedForm, { docType, reportId });
        mapContent(resp);
    } catch (err) {
        console.log(err);
    }
    setGlobalLoading(false);
    final();
}

function* getDownloadDoc(action) {
    const { data, final = () => null, apiUrl } = action.payload;
    try {
        const resp = yield call(apiUrl ?? API.file.downloadDocument, data);
        mapContent(resp);
    } catch (err) {
        console.log(err);
    }

    final();
}

function* downloadGenerateDoc(action) {
    const { id, type, data, callback = () => null } = action.payload;
    try {
        const resp = yield call(API.file.downloadGenerateDoc, { id, type, data });
        mapContent(resp);
    } catch (err) {
        console.log(err);
    }

    callback();
}
/** get download document end */

/** export excel start */
function* exportApplicationSearch(action) {
    const { data, callback } = action.payload;
    try {
        const resp = yield call(API.file.exportApplicationSearch, data);
        console.log(resp);
        mapContent(resp);
    } catch (err) {
        console.log(err);
    }
    callback?.();
}
/** export excel end */

/** export ntec start */
function* exportApplicationSearchNTEC(action) {
    const { data, callback } = action.payload;
    try {
        const resp = yield call(API.file.exportApplicationSearchNTEC, data);
        console.log(resp);
        mapContent(resp);
    } catch (err) {
        console.log(err);
    }
    callback?.();
}
/** export ntec end */

/** download zip file */
function* exportApplication(action) {
    const { data, callback } = action.payload;
    try {
        const resp = yield call(API.file.exportApplication, { data });
        mapContent(resp);
    } catch (err) {
        console.log(err);
    }
    callback?.();
}

function* setFormattedHospitalData(action) {
    const { system } = yield select();
    const { formattedHospitalData } = action.payload;
    system.formattedHospitalData = formattedHospitalData;
    yield put({
        type: SET_SYSTEM,
        payload: system,
    });
}

function* getAllConfig(action) {
    const { system } = yield select();
    try {
        const resp = yield call(API.system.getAllConfig, {});
        const res = resp.data.result;
        let data = system.allConfig;
        data.list = res;

        res.forEach((item) => {
            if (item.code === 'file' && item.subCode === 'maximumSize') {
                if (item.codeValue) data.uploadFileMaxSize = Number(item.codeValue);
            }
            if (item.code === 'crer' && item.subCode === 'file') {
                if (item.codeValue) data.executableFiles.push(`.${item.codeValue}`);
            }
        });

        system.allConfig = data;
        yield put({
            type: SET_SYSTEM,
            payload: system,
        });
    } catch (err) {
        console.log(err);
    }
}

/** system global data (non-auth api) need to initialize here */
function* initialSystemGlobalData(action) {
    const { callback = () => {} } = action.payload;
    const { system: state } = yield select();

    const [newsRes, hospitalRes, authorizedDomain] = yield all([
        call(API.user.getNews, {}),
        call(API.hospital.getAllHospital),
        call(API.authorizedEmail.getAuthorizedDomain),
    ]);

    state.systemNewsAndBroadCastMsg = newsRes?.data?.result;
    state.hospitals = hospitalRes?.data?.result?.hospitals;
    state.clusters = hospitalRes?.data?.result?.clusters;

    /** getSystemMsg */
    // try {
    //     const response = yield call(API.user.getNews, { type: type });
    //     state.systemNewsAndBroadCastMsg = response?.data?.result;
    // } catch (err) {
    //     console.log(err);
    // }

    // /** getAllHospital */
    // try {
    //     const response = yield call(API.hospital.getAllHospital);
    //     state.hospitals = response?.data?.result;
    // } catch (err) {
    //     console.log(err);
    // }

    yield put({
        type: SET_EMAIL_DOMAIN,
        payload: {
            emailDomainList: authorizedDomain?.data?.result?.data,
        },
    });

    yield put({
        type: SET_SYSTEM,
        payload: state,
    });

    callback();
}

/** export CCO start */
function* exportForCCO(action) {
    const { data, callback, type } = action.payload;
    try {
        let typeParam = '';
        switch (type) {
            case 'C': typeParam = 'exportforcco'; break;
            case 'S': typeParam = 'pending'; break;
            case 'H': typeParam = 'pending'; break;
        }
        const resp = yield call(API.file.exportForCCO, { data, type: typeParam });
        console.log(resp);
        mapContent(resp);
    } catch (err) {
        console.log(err);
    }
    callback?.();
}
/** export CCO end */

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SYSTEM:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchSystem() {
    yield takeEvery(INITIAL_SYSTEM_GLOBAL_DATA, safeSaga(initialSystemGlobalData));
    yield takeEvery(SYSTEM_HANDLE_FORCE_CHECK_VALIDATION, safeSaga(handleForceCheckValidation));
    yield takeEvery(SET_FORMATTED_HOSPITAL_DATA, safeSaga(setFormattedHospitalData));
    yield takeEvery(GET_DOWNLOAD_DOCUMENT, safeSaga(getDownloadDoc));
    yield takeEvery(GET_SIGNED_DOCUMENT, safeSaga(getSignedForm));
    yield takeEvery(GET_POST_APPROVAL_ZIP, safeSaga(getPostApprovalZip));
    yield takeEvery(GET_DOWNLOAD_GENERATE_DOC, safeSaga(downloadGenerateDoc));
    yield takeEvery(LOAD_ALL_CONFIG, safeSaga(getAllConfig));
    yield takeEvery(EXPORT_APPLICATION_SEARCH, safeSaga(exportApplicationSearch));
    yield takeEvery(EXPORT_APPLICATION_SEARCH_NTEC, safeSaga(exportApplicationSearchNTEC));
    yield takeEvery(DOWNLOAD_APPLICATION, safeSaga(exportApplication));
    yield takeEvery(EXPORT_FOR_CCO, safeSaga(exportForCCO));
}

export default reducer;
